import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {InventoryService} from './inventory.service';
import {ProductsCategoryService} from './products-category.service';
import {AppComponent} from './app.component';

import {SortTable} from './sort-table.component';
import {Sort} from '@angular/material';
import {ProductsCategory} from './products-category';
import {Router, ActivatedRoute, Params} from '@angular/router';

@Component({
    selector: 'app-inventory',
    templateUrl: './templates/inventory.component.html',
    styleUrls: ['./styles/inventory.component.css'],
    providers: [InventoryService, ProductsCategoryService, SortTable],
    encapsulation: ViewEncapsulation.None
})
export class InventoryComponent implements OnInit {

    article_list: Array<any>;
    article_list_right: Array<any> = [];

    name: any = '';
    internal_code: any = '';
    supplier_code: any = '';
    category: any = '';
    sortedData: any = [];
    inventory_ref: string = "";
    state: string = "";
    id_stocktaking: any;
    showconfirmation: boolean = false;
    categories_list: ProductsCategory[] = [];

    constructor(
        private app_component: AppComponent,
        private inventory_service: InventoryService,
        private product_category_service: ProductsCategoryService,
        private sort_table: SortTable,
        private route: ActivatedRoute,
        private router: Router,
    ) {
        this.app_component.valTest = '/inventory-capture';
        this.app_component.GetParent();
        this.GetStocktakingInfos_cb();
    }

    GetStocktakingInfos_cb(): void {
        this.route.params.subscribe((params: Params) => {
            let id = params['id_stocktaking'];
            this.id_stocktaking = id;
            if (id !== undefined) {
                this.inventory_service.LoadStockTakingInfos(id).then(result => {
                    this.state = result['infos'][0]['status'];
                    this.inventory_ref = 'Réf: ' + result['infos'][0]['reference'] + ' -  ' + result['infos'][0]['name'] + '  (' + result['infos'][0]['status'] + ')';
                    this.article_list_right = result['article_list'];

                });
            }
            else {
                this.DialogBox();
            }
        });
    }

    DialogBox(): void {
        this.showconfirmation = true;
        this.app_component.hide_wrapper(this.showconfirmation);
    }

    BtPopFunction(): void {
        this.router.navigate(['inventories']);
    }

    ngOnInit() {
        this.getArticles();
        this.getCategories();
    }

    getCategories(): void {
        this.product_category_service.GetCategoriesList()
            .then(result => {
                this.categories_list = result;
            });
    }

    getArticles(): void {
        this.inventory_service.getArticles(this.name, this.internal_code, this.supplier_code, this.category)
            .then(result => {
                this.article_list = result['list'];
                this.sortedData = result['list'];
                this.sort_table.SetDataArray(result['list'], [{value: "name", type: ""}, {value: "internal_code", type: ""}, {value: "supplier_code", type: ""}, {value: "category", type: ""}]);
            });
    }

    Sort(sort: Sort): void {
        this.sort_table.sortData(sort);
        this.sortedData = this.sort_table.GetSortData();
    }

    tmp: Array<string> = [];

    countArticle(article: any) {
        this.inventory_service.countArticle(article.id_article, article.name, article.category_name, article.internal_code, article.supplier_code, article.state).then(
            response => {
                this.article_list_right = response['list'];
            });
    }

    toggleBtn(article: any) {
        if (article.state === "NONE") {
            article.state = 'EDIT';
        } else if (article.state === 'EDIT') {
            this.editAndValidateModification(article);
        }
    }

    editAndValidateModification(article: any): void {
        if (isNaN(article.quantity)) {
            article.quantity = 1;
        }
        this.inventory_service.editAndValidateModification(article.id_article, article.quantity_inventaire)
            .then(result => {
                this.article_list_right = result['list'];
            });
    }

    remove(article: any): void {
        this.inventory_service.remove(article.id_article)
            .then(result => {
                this.article_list_right = result['list'];
            });
    }

    disableInput(docket: any): boolean {
        return docket.state === 'NONE';
    }

    doInventory(): void {
        this.inventory_service.doInventory()
            .then(result => {
                this.article_list_right = result['list_right'];
                this.article_list = result['list_left'];
            });
    }

    reset(): void {
        this.router.navigate(['inventories', {id_stocktaking: this.id_stocktaking}]);
        /*console.log(this.article_list_right);
        if (this.article_list_right.length === 0){
            this.router.navigate(['inventories', {id_stocktaking: this.id_stocktaking}]);
        }else{
             this.inventory_service.reset()
            .then(result => {
                this.article_list_right = result['list_right'];
            });
        }
       */
    }

    //    other
    Clean(str: string): string {
        var space = String.fromCharCode(160);
        var res_1 = String(str).replace('&nbsp;', ' ');
        //var res_2 = String(res_1).replace(/space/g, ' ');
        var res_2 = String(res_1).replace(new RegExp(space, 'gi'), ' ');
        return res_2;
    }

    CleanFormatPrice(str_price: string): number {
        var str_price = this.Clean(str_price);
        var no_space = str_price.split(' ');
        return parseInt(no_space.join(''));
    }

    FormatQuantity(article: any, price: string): void {
        if (price !== "") {
            let clean_price = this.CleanFormatPrice(price);
            article.quantity_inventaire = clean_price;
            if (!isNaN(Number(clean_price))) {
                article.quantity_inventaire = Math.round(clean_price).toLocaleString();// + ' Ar';
            } else {
                article.quantity_inventaire = "0";
            }
        } else {
            article.quantity_inventaire = "0";
        }
    }

    formatNumber(price: string): string {
        if (price !== "") {
            let clean_price = this.CleanFormatPrice(price);
            if (!isNaN(Number(clean_price))) {
                return Math.round(clean_price).toLocaleString();
            } else {
                return "0";
            }
        } else {
            return "0";
        }
    }

    RegistredStocktaking(): void {
        this.inventory_service.RegstredStocktaking(this.id_stocktaking, this.state, 'Enregistrer').then(result => {
            let id_stocktaking = result['id_stocktaking'];
            this.router.navigate(['inventories', {id_stocktaking: id_stocktaking}]);
        });
    }

    AnalyseStocktaking(): void {

        this.inventory_service.RegstredStocktaking(this.id_stocktaking, this.state, 'Analyser').then(result => {
            let id_stocktaking = result['id_stocktaking'];

            //Tester si l' utilisateur a le droit d'analyser
            //si oui
                this.router.navigate(['inventory-analysis', {id_stocktaking: id_stocktaking}]);
            //sinon
                //Retourner à la liste d'inventaire
        });

    }
}




// WEBPACK FOOTER //
// ./src/app/inventory.component.ts